import { BrandLogo } from '@/components/icons/brand-logo';

export function FooterSocials() {
  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/company/poly186', '_blank', 'noopener,noreferrer');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/thepolyagency/', '_blank', 'noopener,noreferrer');
  };

  const handleTikTokClick = () => {
    window.open('https://www.tiktok.com/@theagencyofpoly', '_blank', 'noopener,noreferrer');
  };

  const handleGithubClick = () => {
    window.open('https://github.com/Poly186-AI-DAO', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
      <button
        onClick={handleLinkedInClick}
        className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer flex items-center gap-2"
        aria-label="Visit Poly186 LinkedIn page"
      >
        <BrandLogo name="linkedin" className="w-4 h-4" />
        LinkedIn
      </button>
      <button
        onClick={handleInstagramClick}
        className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer flex items-center gap-2"
        aria-label="Visit Agency of Poly Instagram"
      >
        <BrandLogo name="instagram" className="w-4 h-4" />
        Instagram
      </button>
      <button
        onClick={handleTikTokClick}
        className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer flex items-center gap-2"
        aria-label="Visit Agency of Poly TikTok"
      >
        <BrandLogo name="tiktok" className="w-4 h-4" />
        TikTok
      </button>
      <button
        onClick={handleGithubClick}
        className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer flex items-center gap-2"
        aria-label="Visit Poly186 GitHub organization"
      >
        <BrandLogo name="github" className="w-4 h-4" />
        GitHub
      </button>
    </div>
  );
}